import React from "react";
import { useNavigate } from "react-router-dom";
import './Fitness.css';

const FitnessGoal = ({ updateUserData }) => {
    const navigate = useNavigate();

    const handleClick = (goal) => {
        updateUserData({ fitnessGoal: goal });
        navigate('/yourlevel');
    };

    return (
        <div  className="f1">
            <div className="titlee">Your Fitness Goal</div>
            <div className="form">
                <div onClick={() => handleClick('Lose Weight')} className="button">Lose Weight</div>
                <div onClick={() => handleClick('Gain Weight')} className="button">Gain Weight</div>
                <div onClick={() => handleClick('Gain Muscle')} className="button">Gain Muscle</div>
                <button onClick={() => navigate('/age')} className="button backbutton">Back</button>
            </div>
        </div>
    );
};

export default FitnessGoal;
